// Texte für Navigation, Mega Menüs und Fußzeile beider Versionen.
// Version 2: Konzernauftritt mit Utility Leiste. Version 1: Menüstruktur der bisherigen Live Seite, Texte verdichtet und bereinigt.
const P = "/media/parto/";
const E = "/media/parto/echt/";

export default {
    de: {
        ui: {
            all: "Alle ansehen",
            overview: "Übersicht",
            expand: "Bereich aufklappen",
            collapse: "Bereich zuklappen",
            utilLabel: "Servicemenü",
            langLabel: "Sprache",
            more: "Service",
        },
        v2: {
            util: {
                claim: "Komplettlösung für Industriebestände aus einer Hand",
                brandsHint: "Teil der Parto Markenfamilie",
                links: [
                    { label: "Presse", to: "/news" },
                    { label: "Karriere", to: "/careers" },
                    { label: "Standort", to: "/location" },
                    { label: "Kontakt", to: "/contact" },
                ],
            },
            menus: {
                how: {
                    title: "So arbeiten wir",
                    intro: "Ein Ansprechpartner, ein Ablauf. Sie senden die Bestandsliste, Parto erledigt den Rest.",
                    all: { label: "Ablauf ansehen", to: "/how-it-works" },
                    cols: [
                        {
                            title: "Ablauf",
                            items: [
                                { label: "So arbeiten wir", desc: "Vom ersten Gespräch bis zur Abrechnung.", to: "/how-it-works" },
                                { label: "Wege in den Markt", desc: "Für jedes Teil der Weg mit dem besten Erlös.", to: "/how-it-works#wege" },
                                { label: "Ihre Sicherheit", desc: "Klare Verträge und volle Transparenz.", to: "/how-it-works#sicherheit" },
                            ],
                        },
                        {
                            title: "Leistungen",
                            items: [
                                { label: "Leistungen", desc: "Erfassen, lagern, verkaufen, abrechnen. Alles aus einer Hand.", to: "/services" },
                                { label: "Qualität und Sicherheit", desc: "Geprüfte Abläufe und nachvollziehbare Abrechnung.", to: "/quality" },
                            ],
                        },
                    ],
                    teaser: { img: P + "pruefen-messschieber.jpg", title: "Alles aus einer Hand", text: "Von der Bestandsliste bis zur Auszahlung übernimmt Parto jeden Schritt.", cta: { label: "Bestand anfragen", to: "/contact" } },
                },
                stock: {
                    title: "Für Ihren Bestand",
                    intro: "Wählen Sie Ihre Ausgangslage. Parto übernimmt den Rest.",
                    all: { label: "Alle Bestandsarten", to: "/solutions" },
                    colStock: "Nach Bestandsart",
                    colSell: "Direkt verkaufen",
                    colIndustries: "Nach Branche",
                    industries: { label: "Branchen im Überblick", desc: "Für welche Industrien Parto arbeitet.", to: "/industries" },
                    teaser: { img: P + "paletten-halle.jpg", title: "Ihre Bestandsliste genügt", text: "Excel, ERP Export oder Fotos. Den Rest übernimmt Parto.", cta: { label: "Bestand anfragen", to: "/contact" } },
                },
                references: {
                    title: "Referenzen",
                    intro: "Projekte aus der Praxis und Neuigkeiten von Parto.",
                    all: { label: "Alle Referenzen", to: "/references" },
                    cols: [
                        {
                            title: "Projekte",
                            items: [
                                { label: "Referenzen", desc: "Ausgewählte Projekte, Details gern auf Anfrage.", to: "/references" },
                            ],
                        },
                        {
                            title: "Aktuelles",
                            items: [
                                { label: "Presse und Neuigkeiten", desc: "Meldungen, Termine und Ansprechpartner für die Presse.", to: "/news" },
                            ],
                        },
                    ],
                    teaser: { img: E + "produkt-0605.jpg", title: "Ihr Projekt als Nächstes?", text: "Schildern Sie uns kurz Ihr Anliegen. Wir melden uns zeitnah.", cta: { label: "Bestand anfragen", to: "/contact" } },
                },
                about: {
                    title: "Über Parto",
                    intro: "Wer hinter Parto steht und wofür wir stehen.",
                    all: { label: "Unternehmen kennenlernen", to: "/company" },
                    colCompany: "Unternehmen",
                    colMore: "Marken und Verantwortung",
                    extra: [
                        { label: "Markenfamilie", desc: "Parto, BuyParto, HubParto und Parto Assets.", to: "/brands" },
                        { label: "Nachhaltigkeit", desc: "Teile weiter nutzen statt verschrotten.", to: "/sustainability" },
                        { label: "Standort und Lager", desc: "Wo Sie uns finden.", to: "/location" },
                    ],
                    teaser: { img: E + "firmengebaeude.jpg", title: "Parto Solution GmbH", text: "Ihr Partner für Industriebestände, mit Sitz in Rheine.", cta: { label: "Kontakt aufnehmen", to: "/contact" } },
                },
            },
            footer: {
                colHow: "Ablauf und Leistungen",
                how: [
                    { label: "So arbeiten wir", to: "/how-it-works" },
                    { label: "Leistungen", to: "/services" },
                    { label: "Qualität und Sicherheit", to: "/quality" },
                    { label: "Wege in den Markt", to: "/how-it-works#wege" },
                    { label: "Referenzen", to: "/references" },
                ],
                industries: { label: "Branchen", to: "/industries" },
                colAbout: "Über Parto",
                about: [
                    { label: "Unternehmen", to: "/company" },
                    { label: "Markenfamilie", to: "/brands" },
                    { label: "Nachhaltigkeit", to: "/sustainability" },
                    { label: "Netzwerk und Kanäle", to: "/ecosystem" },
                    { label: "Partner werden", to: "/partners" },
                ],
                colService: "Service",
                service: [
                    { label: "Presse und Neuigkeiten", to: "/news" },
                    { label: "Karriere", to: "/careers" },
                    { label: "Standort und Lager", to: "/location" },
                    { label: "Kontakt", to: "/contact" },
                ],
            },
        },
        v1: {
            cta: "Mit Parto sprechen",
            menus: {
                infrastructure: {
                    title: "Parto Infrastruktur",
                    intro: "Die operative Infrastruktur für industrielle Bestände nach der Freigabe.",
                    all: { label: "Infrastruktur verstehen", to: "/infrastructure" },
                    cols: [
                        {
                            title: "Drei Ebenen",
                            items: [
                                { label: "Asset-Daten", desc: "Wissen, was vorhanden ist.", to: "/infrastructure#asset-data" },
                                { label: "Asset Operations", desc: "Das Physische professionell umsetzen.", to: "/infrastructure#asset-operations" },
                                { label: "Marktzugang und Verwertung", desc: "Den wirtschaftlich passenden Weg finden.", to: "/infrastructure#market-access" },
                            ],
                        },
                        {
                            title: "Darüber",
                            items: [
                                { label: "Steuerung und Transparenz", desc: "Für jedes Asset sehen, wo es steht.", to: "/infrastructure#control-visibility" },
                                { label: "Der Ablauf", desc: "Von der Freigabe bis zum wirtschaftlichen Abschluss.", to: "/infrastructure#process" },
                            ],
                        },
                    ],
                    teaser: { img: P + "lagergang.jpg", title: "Sie geben frei, Parto erledigt den Rest.", text: "Daten, physische Umsetzung und Marktzugang in einem Prozess.", cta: { label: "Mit Parto sprechen", to: "/contact" } },
                },
                solutions: {
                    title: "Solutions",
                    intro: "Lösungen nach Ausgangssituation und für Bestände, die Sie abgeben wollen.",
                    all: { label: "Alle Solutions ansehen", to: "/solutions" },
                    cols: [
                        {
                            title: "Nach Ausgangssituation",
                            items: [
                                { label: "Surplus und Excess Inventory", desc: "Überschüsse in einen steuerbaren Prozess bringen.", to: "/solutions/surplus-excess" },
                                { label: "Obsolete und Slow Moving", desc: "Einen Weg für Bestände schaffen, die zurückbleiben.", to: "/solutions/obsolete-slow-moving" },
                                { label: "MRO und Spare Parts", desc: "Behalten, was wichtig ist. Freigeben, was nicht gebraucht wird.", to: "/solutions/mro-spare-parts" },
                                { label: "Werkstilllegung und Restrukturierung", desc: "Bestände bei Veränderungen strukturiert steuern.", to: "/solutions/plant-closures" },
                            ],
                        },
                        {
                            title: "Bestände abzugeben?",
                            items: [
                                { label: "Industrielle Bestände", desc: "Industriebestand verkaufen.", to: "/solutions/sell-industrial-inventory" },
                                { label: "Überbestände", desc: "Überbestand an den Markt bringen.", to: "/solutions/sell-surplus-inventory" },
                                { label: "Maschinen und Anlagen", desc: "Gebrauchte Maschinen verkaufen.", to: "/solutions/sell-machinery-equipment" },
                                { label: "Standort und Betriebsschließungen", desc: "Ganze Standorte räumen.", to: "/solutions/plant-closures-restructuring" },
                            ],
                        },
                    ],
                    teaser: { img: P + "werkhalle-maschinen.jpg", title: "Bestände mit Klärungsbedarf?", text: "Sie entscheiden über die Freigabe. Parto übernimmt den weiteren Prozess.", cta: { label: "Bestand besprechen", to: "/contact" } },
                },
                roles: {
                    title: "Parto für Ihre Rolle",
                    intro: "Jede Rolle sieht Überbestand anders. Parto entlastet alle.",
                    all: { label: "Lösung nach Rolle ansehen", to: "/by-role" },
                    cols: [
                        {
                            title: "Rollen",
                            items: [
                                { label: "Operations und Management", desc: "Operativen Aufwand nach der Freigabe reduzieren.", to: "/by-role/operations" },
                                { label: "Maintenance und MRO", desc: "Ersatzteile und Altbestände systematisch steuern.", to: "/by-role/maintenance-mro" },
                                { label: "Supply Chain und Procurement", desc: "Bestandstransparenz, Kontrolle, Wert.", to: "/by-role/supply-chain-procurement" },
                                { label: "Finance und Controlling", desc: "Mehr Transparenz über Bestände und Erlöse.", to: "/by-role/finance" },
                            ],
                        },
                    ],
                    teaser: { img: P + "techniker-getriebe.jpg", title: "Ein Ansprechpartner für alle", text: "Einkauf, Instandhaltung, Werk und Finanzen arbeiten mit einem Partner.", cta: { label: "Mit Parto sprechen", to: "/contact" } },
                },
                insights: {
                    title: "Parto Insights",
                    intro: "Projekte, Prozesse und Perspektiven rund um industrielle Bestände.",
                    all: { label: "Alle Insights", to: "/insights" },
                    cols: [
                        {
                            title: "Insights",
                            items: [
                                { label: "Referenzen", desc: "Typische Projekte aus der Praxis.", to: "/insights/references" },
                                { label: "Case Studies", desc: "Den Prozess hinter dem Ergebnis verstehen.", to: "/insights/case-studies" },
                                { label: "Fachartikel", desc: "Perspektiven auf Industrial Asset Operations.", to: "/insights/articles" },
                                { label: "News und Presse", desc: "Aktuelles von Parto.", to: "/insights/news" },
                            ],
                        },
                    ],
                    teaser: { img: E + "produkt-0617.jpg", title: "Ihr Projekt als Nächstes?", text: "Erzählen Sie uns kurz, worum es geht.", cta: { label: "Mit Parto sprechen", to: "/contact" } },
                },
                company: {
                    title: "Unternehmen",
                    intro: "Wer wir sind und warum wir Parto aufbauen.",
                    all: { label: "Parto kennenlernen", to: "/company" },
                    cols: [
                        {
                            title: "Parto",
                            items: [
                                { label: "Über Parto", desc: "Wer wir sind und warum wir Parto aufbauen.", to: "/company" },
                                { label: "Ecosystem", desc: "Parto, HubParto, Parto Assets und das Parto Network.", to: "/ecosystem" },
                                { label: "Partner", desc: "Bringen Sie Ihre Stärken in den Prozess ein.", to: "/partners" },
                            ],
                        },
                        {
                            title: "Mehr",
                            items: [
                                { label: "Nachhaltigkeit und Kreislaufwirtschaft", desc: "Industrielle Assets im Kreislauf halten.", to: "/sustainability" },
                                { label: "Careers", desc: "Gemeinsam die Infrastruktur für industrielle Assets aufbauen.", to: "/careers" },
                                { label: "Kontakt", desc: "Erzählen Sie uns kurz, worum es geht.", to: "/contact" },
                            ],
                        },
                    ],
                    teaser: { img: E + "firmengebaeude-2.jpg", title: "Parto Solution GmbH", text: "Industrielle Bestände sinnvoll weiterführen.", cta: { label: "Mit Parto sprechen", to: "/contact" } },
                },
            },
            footer: {
                tagline: "Die operative Infrastruktur für industrielle Bestände. Verkauf im Auftrag oder Sofortankauf über BuyParto.",
                colContact: "Kontakt",
                colChannels: "Parto Ecosystem",
                contactLink: "Kontaktformular",
            },
        },
    },
    en: {
        ui: {
            all: "View all",
            overview: "Overview",
            expand: "Expand section",
            collapse: "Collapse section",
            utilLabel: "Service menu",
            langLabel: "Language",
            more: "Service",
        },
        v2: {
            util: {
                claim: "The complete solution for industrial inventory, from one source",
                brandsHint: "Part of the Parto brand family",
                links: [
                    { label: "Press", to: "/news" },
                    { label: "Careers", to: "/careers" },
                    { label: "Location", to: "/location" },
                    { label: "Contact", to: "/contact" },
                ],
            },
            menus: {
                how: {
                    title: "How we work",
                    intro: "One contact, one process. You send the inventory list, Parto does the rest.",
                    all: { label: "See the process", to: "/how-it-works" },
                    cols: [
                        {
                            title: "Process",
                            items: [
                                { label: "How we work", desc: "From the first call to the final statement.", to: "/how-it-works" },
                                { label: "Routes to market", desc: "The best paying route for every part.", to: "/how-it-works#wege" },
                                { label: "Your security", desc: "Clear contracts and full transparency.", to: "/how-it-works#sicherheit" },
                            ],
                        },
                        {
                            title: "Services",
                            items: [
                                { label: "Services", desc: "Capture, store, sell, settle. All from one source.", to: "/services" },
                                { label: "Quality and security", desc: "Checked processes and auditable statements.", to: "/quality" },
                            ],
                        },
                    ],
                    teaser: { img: P + "pruefen-messschieber.jpg", title: "Everything from one source", text: "From the inventory list to the payout, Parto handles every step.", cta: { label: "Request a review", to: "/contact" } },
                },
                stock: {
                    title: "Your inventory",
                    intro: "Choose your situation. Parto handles the rest.",
                    all: { label: "All inventory types", to: "/solutions" },
                    colStock: "By inventory type",
                    colSell: "Sell directly",
                    colIndustries: "By industry",
                    industries: { label: "Industries overview", desc: "The industries Parto works for.", to: "/industries" },
                    teaser: { img: P + "paletten-halle.jpg", title: "Your inventory list is enough", text: "Excel, ERP export or photos. Parto handles the rest.", cta: { label: "Request a review", to: "/contact" } },
                },
                references: {
                    title: "References",
                    intro: "Projects from practice and news from Parto.",
                    all: { label: "All references", to: "/references" },
                    cols: [
                        { title: "Projects", items: [{ label: "References", desc: "Selected projects, details on request.", to: "/references" }] },
                        { title: "News", items: [{ label: "Press and news", desc: "Announcements, dates and press contact.", to: "/news" }] },
                    ],
                    teaser: { img: E + "produkt-0605.jpg", title: "Your project next?", text: "Briefly describe your request. We will get back to you promptly.", cta: { label: "Request a review", to: "/contact" } },
                },
                about: {
                    title: "About Parto",
                    intro: "Who is behind Parto and what we stand for.",
                    all: { label: "Get to know the company", to: "/company" },
                    colCompany: "Company",
                    colMore: "Brands and responsibility",
                    extra: [
                        { label: "Brand family", desc: "Parto, BuyParto, HubParto and Parto Assets.", to: "/brands" },
                        { label: "Sustainability", desc: "Keep parts in use instead of scrapping them.", to: "/sustainability" },
                        { label: "Location and warehouse", desc: "Where to find us.", to: "/location" },
                    ],
                    teaser: { img: E + "firmengebaeude.jpg", title: "Parto Solution GmbH", text: "Your partner for industrial inventory, based in Rheine, Germany.", cta: { label: "Get in touch", to: "/contact" } },
                },
            },
            footer: {
                colHow: "Process and services",
                how: [
                    { label: "How we work", to: "/how-it-works" },
                    { label: "Services", to: "/services" },
                    { label: "Quality and security", to: "/quality" },
                    { label: "Routes to market", to: "/how-it-works#wege" },
                    { label: "References", to: "/references" },
                ],
                industries: { label: "Industries", to: "/industries" },
                colAbout: "About Parto",
                about: [
                    { label: "Company", to: "/company" },
                    { label: "Brand family", to: "/brands" },
                    { label: "Sustainability", to: "/sustainability" },
                    { label: "Network and channels", to: "/ecosystem" },
                    { label: "Become a partner", to: "/partners" },
                ],
                colService: "Service",
                service: [
                    { label: "Press and news", to: "/news" },
                    { label: "Careers", to: "/careers" },
                    { label: "Location and warehouse", to: "/location" },
                    { label: "Contact", to: "/contact" },
                ],
            },
        },
        v1: {
            cta: "Talk to Parto",
            menus: {
                infrastructure: {
                    title: "Parto Infrastructure",
                    intro: "The operating layer for industrial inventory after release.",
                    all: { label: "Explore the infrastructure", to: "/infrastructure" },
                    cols: [
                        {
                            title: "Three layers",
                            items: [
                                { label: "Asset Data", desc: "Know what you have.", to: "/infrastructure#asset-data" },
                                { label: "Asset Operations", desc: "Handle what is physical.", to: "/infrastructure#asset-operations" },
                                { label: "Market Access and Value", desc: "Find the right path to value.", to: "/infrastructure#market-access" },
                            ],
                        },
                        {
                            title: "On top",
                            items: [
                                { label: "Control and Visibility", desc: "See where every asset stands.", to: "/infrastructure#control-visibility" },
                                { label: "The process", desc: "From release to economic close.", to: "/infrastructure#process" },
                            ],
                        },
                    ],
                    teaser: { img: P + "lagergang.jpg", title: "You release, Parto does the rest.", text: "Data, physical handling and market access in one process.", cta: { label: "Talk to Parto", to: "/contact" } },
                },
                solutions: {
                    title: "Solutions",
                    intro: "Solutions by situation, and for inventory you want to release.",
                    all: { label: "View all Solutions", to: "/solutions" },
                    cols: [
                        {
                            title: "By situation",
                            items: [
                                { label: "Surplus and Excess Inventory", desc: "Turn excess inventory into an operated process.", to: "/solutions/surplus-excess" },
                                { label: "Obsolete and Slow Moving", desc: "Create a path for inventory left behind.", to: "/solutions/obsolete-slow-moving" },
                                { label: "MRO and Spare Parts", desc: "Keep what matters. Release what doesn't.", to: "/solutions/mro-spare-parts" },
                                { label: "Plant Closures and Restructuring", desc: "Move industrial inventory through change.", to: "/solutions/plant-closures" },
                            ],
                        },
                        {
                            title: "Have assets to release?",
                            items: [
                                { label: "Industrial Assets", desc: "Sell industrial inventory.", to: "/solutions/sell-industrial-inventory" },
                                { label: "Surplus Inventory", desc: "Bring surplus stock to market.", to: "/solutions/sell-surplus-inventory" },
                                { label: "Machinery and Equipment", desc: "Sell used machines.", to: "/solutions/sell-machinery-equipment" },
                                { label: "Plant and Site Closures", desc: "Clear entire sites.", to: "/solutions/plant-closures-restructuring" },
                            ],
                        },
                    ],
                    teaser: { img: P + "werkhalle-maschinen.jpg", title: "Have assets to discuss?", text: "You decide what to release. Parto operates what comes next.", cta: { label: "Discuss your assets", to: "/contact" } },
                },
                roles: {
                    title: "Parto for your role",
                    intro: "Every role sees surplus differently. Parto takes the load off all of them.",
                    all: { label: "Explore by role", to: "/by-role" },
                    cols: [
                        {
                            title: "Roles",
                            items: [
                                { label: "Operations and Management", desc: "Reduce the operational burden behind released assets.", to: "/by-role/operations" },
                                { label: "Maintenance and MRO", desc: "Manage legacy and spare part inventory systematically.", to: "/by-role/maintenance-mro" },
                                { label: "Supply Chain and Procurement", desc: "Inventory visibility, control, value.", to: "/by-role/supply-chain-procurement" },
                                { label: "Finance and Controlling", desc: "More visibility into inventory and proceeds.", to: "/by-role/finance" },
                            ],
                        },
                    ],
                    teaser: { img: P + "techniker-getriebe.jpg", title: "One contact for everyone", text: "Procurement, maintenance, operations and finance work with one partner.", cta: { label: "Talk to Parto", to: "/contact" } },
                },
                insights: {
                    title: "Parto Insights",
                    intro: "Projects, processes and perspectives on industrial inventory.",
                    all: { label: "All Insights", to: "/insights" },
                    cols: [
                        {
                            title: "Insights",
                            items: [
                                { label: "References", desc: "Typical projects from practice.", to: "/insights/references" },
                                { label: "Case Studies", desc: "See the process behind the result.", to: "/insights/case-studies" },
                                { label: "Articles", desc: "Perspectives on industrial asset operations.", to: "/insights/articles" },
                                { label: "News and Press", desc: "What's happening at Parto.", to: "/insights/news" },
                            ],
                        },
                    ],
                    teaser: { img: E + "produkt-0617.jpg", title: "Your project next?", text: "Tell us briefly what it's about.", cta: { label: "Talk to Parto", to: "/contact" } },
                },
                company: {
                    title: "Company",
                    intro: "Who we are and why we're building Parto.",
                    all: { label: "Discover the company", to: "/company" },
                    cols: [
                        {
                            title: "Parto",
                            items: [
                                { label: "About Parto", desc: "Who we are and why we're building Parto.", to: "/company" },
                                { label: "Ecosystem", desc: "Parto, HubParto, Parto Assets and the Parto Network.", to: "/ecosystem" },
                                { label: "Partners", desc: "Bring your capabilities into the asset process.", to: "/partners" },
                            ],
                        },
                        {
                            title: "More",
                            items: [
                                { label: "Sustainability and circular economy", desc: "Keep industrial assets in the loop.", to: "/sustainability" },
                                { label: "Careers", desc: "Build the infrastructure for industrial assets with us.", to: "/careers" },
                                { label: "Contact", desc: "Tell us briefly what it's about.", to: "/contact" },
                            ],
                        },
                    ],
                    teaser: { img: E + "firmengebaeude-2.jpg", title: "Parto Solution GmbH", text: "Keep industrial assets in productive use.", cta: { label: "Talk to Parto", to: "/contact" } },
                },
            },
            footer: {
                tagline: "The operating layer for industrial inventory. Consignment sale or instant buyout through BuyParto.",
                colContact: "Contact",
                colChannels: "Parto Ecosystem",
                contactLink: "Contact form",
            },
        },
    },
};
